import { getPocketBase, escFilter as esc } from '../pocketbase.js';
import { normalizeStudioDraft, isStudioDraftEmpty } from '../studioDrafts.js';

/** Riga PocketBase → bozza app `{ maxPrice, notes, labels }`. */
export function rowToStudioDraft(row = {}) {
  return normalizeStudioDraft({
    maxPrice: row.max_price,
    notes: row.notes,
    labels: row.labels,
  });
}

/** Bozza app → campi PocketBase (senza access_key / player_key). */
export function studioDraftToRowFields(draft = {}) {
  const n = normalizeStudioDraft(draft);
  return {
    max_price: n.maxPrice,
    notes: n.notes,
    labels: n.labels,
  };
}

/**
 * Mappa player_key → bozza normalizzata per un access_key.
 * @returns {Record<string, { maxPrice: number, notes: string, labels: string[] }>}
 */
export async function fetchStudioDrafts(accessKey, pbOverride) {
  const pb = pbOverride || getPocketBase();
  const rows = await pb.collection('studio_drafts').getFullList({
    filter: `access_key="${esc(accessKey)}"`,
  });
  const out = {};
  for (const r of rows) {
    const key = String(r.player_key || '').trim();
    if (!key) continue;
    const draft = rowToStudioDraft(r);
    if (isStudioDraftEmpty(draft)) continue;
    out[key] = draft;
  }
  return out;
}

export async function upsertStudioDraft(
  { accessKey, playerKey, maxPrice, notes, labels },
  pbOverride,
) {
  const pb = pbOverride || getPocketBase();
  const draft = normalizeStudioDraft({ maxPrice, notes, labels });
  if (isStudioDraftEmpty(draft)) {
    return deleteStudioDraft(accessKey, playerKey, pbOverride);
  }
  const data = {
    access_key: accessKey,
    player_key: playerKey,
    ...studioDraftToRowFields(draft),
  };
  const existing = await pb.collection('studio_drafts').getFullList({
    filter: `access_key="${esc(accessKey)}" && player_key="${esc(playerKey)}"`,
  });
  if (existing.length) return pb.collection('studio_drafts').update(existing[0].id, data);
  return pb.collection('studio_drafts').create(data);
}

export async function deleteStudioDraft(accessKey, playerKey, pbOverride) {
  const pb = pbOverride || getPocketBase();
  const existing = await pb.collection('studio_drafts').getFullList({
    filter: `access_key="${esc(accessKey)}" && player_key="${esc(playerKey)}"`,
  });
  for (const r of existing) await pb.collection('studio_drafts').delete(r.id);
  return { deleted: existing.length };
}
